<template>
    <div>
        <div class="border rounded p-3 p-xxl-4 mb-2 overflow-y-scroll overflow-x-hidden position-sticky profile-image">
            <div class="row">
                <div class="col-5 col-lg-12">
                    <div class="embed-responsive embed-responsive-1by1 rounded mb-4 d-flex justify-content-center align-items-center text-muted bg-cover-center bg-gray-50"
                        :style="{backgroundImage: photo ? 'url(' + photo + ')':''}">
                        <i class="ri-user-4-line ri-3x mb-3" v-if="!photo"/>
                        <div class="d-flex justify-content-between position-absolute bottom-0 w-100 p-2"
                             v-if="editMode">
                            <button class="btn btn-xs font-weight-normal bg-gray-50 rounded"
                                    @click="uploadPhotoModalShow">
                                <i class="ri-upload-2-line font-size-base"></i>
                            </button>
<!--                            <button class="btn btn-xs font-weight-normal bg-gray-50 rounded"-->
<!--                                    @click="openCamera">-->
<!--                                <i class="ri-camera-line font-size-base"></i>-->
<!--                            </button>-->
                            <button class="btn btn-xs font-weight-normal bg-gray-50 rounded text-danger">
                                <i class="ri-delete-bin-line font-size-base"></i>
                            </button>
                        </div>
                        <div class="spinner over bg-white-50 d-none">
                            <b-spinner small label="spinning" class="text-primary"></b-spinner>
                        </div>
                    </div>

                </div>
                <div class="col-7 col-lg-12">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">
                                    {{ $t('name') + ' ' + $t('surname') }}
                                </label>
                                {{ staffInformation.name ? staffInformation.name : ' - ' }}
                                {{ staffInformation.surname ? staffInformation.surname : ' - ' }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">{{ $t('mobile_number') }}</label>
                                {{ staffInformation.mobile_tel ? staffInformation.mobile_tel : ' - ' }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">{{ $t('email') }}</label>
                                {{ staffInformation.email ? staffInformation.email : ' - ' }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">{{ $t('gender') }}</label>
                                {{ staffInformation.gender ? staffInformation.gender : ' - ' }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">{{ $t('start_date') }}</label>
                                {{ staffInformation.start_date ? staffInformation.start_date : ' - ' }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <b-form-group class="mb-2">
                                <label class="col-form-label p-0 pb-1 d-block">{{ $t('end_date') }}</label>
                                {{ staffInformation.end_date ? staffInformation.end_date : ' - ' }}
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonModal ref="uploadPhotoModal" :onHideOnlyX="true" v-if="editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('image_upload').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <b-form-group :label="$t('photo')" class="mb-2">
                    <div class="d-flex custom-file-upload mb-2">
                        <b-form-file
                            v-model="photoFile"
                            :placeholder="$t('select_file')"
                            :drop-placeholder="$t('drop_file')"
                            ref="fileInput"
                            accept="image/jpeg, image/png, image/gif"
                        >
                        </b-form-file>
                        <b-button v-if="hasPhoto" variant="danger" @click="clearPhoto">
                            <i class="ri-close-fill"></i>
                        </b-button>
                        <b-button v-else variant="outline-secondary"
                                  @click="$refs.fileInput.$el.childNodes[0].click();">
                            <i class="ri-add-fill"></i>
                        </b-button>
                    </div>
                    <b-img v-if="hasPhoto" :src="photoFileSrc" fluid block rounded></b-img>
                </b-form-group>
                <b-button variant="primary" block v-if="hasPhoto" @click="uploadSignature">{{ $t('upload') }}</b-button>
            </template>
        </CommonModal>
        <CommonModal ref="openUploadCameraModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="closeCamera"  v-if="editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('take_a_photo').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <camera-component
                    :open-camera.sync="isCameraOpen"
                    :upload-handler="uploadSignature"
                    @camera-error="handleCameraError"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Components
    import CommonModal from '@/components/elements/CommonModal';
    // Helper
    import toBase64 from '@/helpers/toBase64'
    // Services
    import CameraComponent from "@/components/interactive-fields/CameraComponent.vue";
    import StaffService from "@/services/StaffService";
    export default {
        components: {
            CameraComponent,
            CommonModal
        },
        props: {
            staffInformation: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            },
            userId: {
                type: Number,
                default: 0
            }
        },
        watch: {
            userId(newValue) {
                if (newValue) {
                    this.staffId=newValue;
                    this.GetProfilePhoto(newValue);
                }
            },
            photoFile(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue) {
                        this.base64Encode(newValue)
                            .then(value => {
                                this.photoFileSrc = value;
                            })
                            .catch(() => {
                                this.photoFileSrc = null;
                            });
                    }
                    else {
                        this.photoFileSrc = null;
                    }
                }
            }
        },
        data() {
            return {
                isCameraOpen:false,
                hi: false,
                staffId:null,
                photoFile: null,
                photoFileSrc: null,
                photo: null,
                photoUploadProcess: false
            }
        },
        computed: {
            hasPhoto() {
                return !!this.photoFile;
            }
        },
        methods: {
            toBase64: toBase64,
            GetProfilePhoto(userId) {
                StaffService.personGetProfilePhoto(userId).then(response => {
                    if (response.data.byteLength > 1) {
                        const blob = new Blob([response.data], { type: 'image/jpeg' });
                        this.photo = URL.createObjectURL(blob);
                    }
                }).catch(e => {
                    this.showErrors(e, null, true);
                });
            },
            closeCamera(){
                this.$refs.openUploadCameraModal.$refs.commonModal.hide()
                this.isCameraOpen = false;
            },
            openCamera() {
                this.$refs.openUploadCameraModal.$refs.commonModal.show()
                this.isCameraOpen = true;

            },
            uploadSignature() {
                    let formData = new FormData()
                    formData.append('file', this.photoFile)
                    StaffService.personUploadPhoto(formData, this.$route.params.id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    }).finally(() => {
                        this.photoFile = null;
                        this.GetProfilePhoto(this.staffId);
                        this.uploadPhotoModalHide()
                    })
            },
            handleCameraError(error) {
                this.$toast.error('Could not open camera. Please check permissions.');
                this.isCameraOpen = false;
            },
            uploadPhotoModalShow() {
                this.$refs.uploadPhotoModal.$refs.commonModal.show()
            },
            uploadPhotoModalHide() {
                this.$refs.uploadPhotoModal.$refs.commonModal.hide()
            },
            clearPhoto() {
                this.photoFile = null;
            },

        }
    }
</script>
<style scoped>
    .profile-image {
        width: 100%;
    }

    @media screen and (min-width: 992px) {
        .profile-image {
            width: 200px
        }
    }

    @media screen and (min-width: 1281px) {
        .profile-image {
            width: 250px
        }
    }
</style>
